import Hamburger from 'hamburger-react';
import React from 'react';
import { Button, Container, Nav, Navbar } from 'react-bootstrap';
import title from '../../images/Navbar/title.png';
import './NavBar.scss';

const NavBar = () => (
    <Navbar className="nav-container" expand="lg" sticky="top">
        <Container>
            <Navbar.Brand href="#home">
                <img src={title} alt="TechTack" />
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" className="navbar-icon">
                <Hamburger direction="right" />
            </Navbar.Toggle>
            <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="nav-link-margin">
                    <Nav.Link className="hover-underline-animation" href="#home">
                        Services
                    </Nav.Link>
                    <Nav.Link className="hover-underline-animation" href="#link">
                        Why Us
                    </Nav.Link>
                    <Nav.Link className="hover-underline-animation" href="#link">
                        Pricing
                    </Nav.Link>
                    <Nav.Link className="hover-underline-animation" href="#link">
                        Review
                    </Nav.Link>
                </Nav>
                <Nav className="ms-auto">
                    <Nav.Link href="#home">
                        <Button className="px-3" variant="dark">
                            Get Quotes
                        </Button>
                    </Nav.Link>
                </Nav>
            </Navbar.Collapse>
        </Container>
    </Navbar>
);

export default NavBar;
